import 'selectize/dist/js/selectize.min.js';
import '../util/jquery.multi-select.min.js';

var ajax_type_filter_form = $('.ajax-type-filter-form:not(.ajax-type-filter-form-partners)');
if (ajax_type_filter_form.length > 0) {

  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  var multiple = $('.ajax-type-filter-form').hasClass('multiple');
  var form = $('.ajax-type-filter-form');

  if (multiple) {
    $('.ajax-type-filter-form.multiple select').each(function(){
      var allText = $(this).attr('data-default-label');

      $(this).multiSelect({
        'noneText': allText,
      });
    });

    $('.ajax-filters .btn-reset').on('click', function () {
      if ($(this).hasClass('reset')) {
        $.ajaxSetup({async: false});

        $('.ajax-type-filter-form.multiple select').each(function () {
          var $select = $(this);
          var isSomeOptionChecked = !!($select.find('option:selected').length);

          $select.siblings('.multi-select-container input[type=checkbox]:checked').prop('checked', false);
          $select.find('option:selected').prop('selected', false);

          if (isSomeOptionChecked) {
            $select.trigger('change');
          }
        });

        $.ajaxSetup({async: true});
        $(this).removeClass('reset');
      }
    });
  }

  $('.ajax-type-filter-form select').each(function() {
    var select = $(this);
    var select_name = select.attr('name');
    var getVal = urlParams.get(select_name);

    if (getVal != null) {
      if (form.hasClass('multiple')) {
        var vals = getVal.split(',');
        vals.forEach(function(element){
          form.find('.multi-select-container input[value="'+element+'"]').prop('checked', true);
          form.find('select option[value="'+element+'"]').prop('selected', true);
        });

      } else {
        select.val(getVal);
      }
    }
  });

  form.find('select').trigger('change');

  $(document).on('change', '.ajax-type-filter-form select', function () {
    console.log('changetriggerded');
    var $resetBtn = $(this).parents('form').siblings('.btn-reset');
    var reset = false;
    var tax_query = {};
    var i = 0;
    var post_type = $(this).attr('data-post-type');

    $('.ajax-type-filter-form select').each(function() {
      if ($(this).find('option:selected').length) {
        reset = true;
      }

      var val       = $(this).val() || 'all';
      var name      = $(this).attr('name');
      var taxonomy  = $(this).attr('data-taxonomy');

      tax_query[i] = {
        taxonomy: taxonomy,
        value: val,
      }

      if (post_type == 'success_story') {
        $(this).parents('form').submit();
        return;
      }

      if (Array.isArray(val) && !val.length) {
        val = 'all';
      }

      // Update URL with param
      var uri = window.location.href;
      var re = new RegExp('([?&])' + name + '=.*?(&|$)', 'i');
      var separator = uri.indexOf('?') !== -1 ? '&' : '?';
      if (uri.match(re)) {
        window.history.pushState({path: uri.replace(re, '$1' + name + '=' + val + '$2')}, '', uri.replace(re, '$1' + name + '=' + val + '$2')) ;
      }
      else {
        window.history.pushState({path: uri + separator + name + '=' + val}, '', uri + separator + name + '=' + val) ;
      }

      i++;
    });

    if (!reset) {
      $resetBtn.removeClass('reset').text( $resetBtn.data('sort') );
    } else {
      $resetBtn.addClass('reset').text( $resetBtn.data('reset') );
    }

    var data = window['binah_data_' + post_type];

    if (window.xhr) {
      window.xhr.abort();
    }

    window.xhr = $.post(
      data.ajaxurl, {
        action    : 'ajax_filter_type',
        post_type : post_type,
        tax_query : JSON.stringify(tax_query),

        query         : data.posts,
        page          : 0,
        item_template : data.item_template,
        async         : false,
      },
      function (res) {
        var parsed = $.parseJSON(res);

        window[ 'binah_data_' + post_type ].posts = parsed.query;
        window[ 'binah_data_' + post_type ].current_page = 1;
        window[ 'binah_data_' + post_type ].max_page = parsed.max_page;

        if( parsed['data'] ) {
          $('.posts-listing').html( parsed['data'] );
          $('.alert-warning').hide();
          
          if(window.macyGrid){
            window.macyGrid.resizer();
          }
        } else {
          $('.posts-listing').html('');
          $('.alert-warning').show();
        }

        $('.component-btn-load-more .btn-go-to-top').hide();
        $('.btn-load-more-posts').show().html('Load more');
      }
    );

  });
}



// WEBPACK FOOTER //
// ./scripts/components/ajax-type-filter.js